<script setup lang="ts">
  import BusySpinner from '@/components/ui/spinners/BusySpinner.vue'

  withDefaults(
    defineProps<{
      busy: boolean
      label?: string
    }>(),
    { label: 'Loading' },
  )
</script>

<template>
  <div class="busy-overlay">
    <slot />

    <div v-if="busy" role="status" :aria-label="label" class="busy-overlay__veil">
      <BusySpinner />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .busy-overlay {
    position: relative;
  }

  .busy-overlay__veil {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.78);
    backdrop-filter: blur(1px);
  }
</style>
